import { AutoComplete, Input } from "antd";
import React, { useState } from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import { labels } from "../../../../localization/labels";
import CommonUtil from "../../../../utils/CommonUtil";
import { constants } from "../../../../utils/Constants";
import SubmitButton from "../../../core/SubmitButton";
import KnowledgeManagement from "../../KnowledgeManagement";
import KnowledgeItemBasic from "../../KnowledgeManagement/KnowledgeItem/KnowledgeItemBasic";
import KnowledgeManagementSearch from "../../KnowledgeManagement/KnowledgeManagementSearch";
import Bam from "../Bam";

const Home = ({
  searchValue,
  searchHistory,
  onSearchChange,
  onSearch,
  messageHandler,
  breadcrumbsHandler,
  onTagClick,
  onClassificationClick,
  selectedWord,
  selectedClassification,
  showTable,
  shouldSearch,
  parentResetComponent,
  beforeOnShowKnowledgeItem
}) => {
  var searchPlaceholderAddition = {};
  if (selectedWord) {
    searchPlaceholderAddition[labels.tag] = selectedWord.fullText;
  }
  if (selectedClassification) {
    searchPlaceholderAddition[labels.classification] =
      selectedClassification.classificationName;
  }

  const [show, setShow] = React.useState(false);
  const [openHistory, setOpenHistory] = useState(false);

  const handlerProps = {
    messageHandler: messageHandler,
    breadcrumbsHandler: breadcrumbsHandler
  };

  return (
    <>
      <div className="container">
        <Row className="search-container">
          <Col sm="9">
            <div className={"Application-Title-Container"}>
              <FormLabel className={"Application-Title"}>
                {labels.applicationNameLong}
              </FormLabel>
            </div>
            <Row>
              <Col>
                <div className="container-searh-create">
                  <div className="search-div">
                    <AutoComplete
                      style={{ width: "100%" }}
                      autoFocus
                      value={searchValue}
                      open={openHistory}
                      options={searchHistory}
                      onChange={data => {
                        onSearchChange({ target: { value: data } });
                      }}
                      filterOption={(inputValue, option) =>
                        option?.value
                          ?.toUpperCase()
                          ?.indexOf(inputValue?.toUpperCase()) !== -1
                      }
                      onDropdownVisibleChange={open => setOpenHistory(open)}
                    >
                      <Input.Search
                        autoFocus
                        placeholder={CommonUtil.addToStringWithBrackets(
                          labels.search,
                          searchPlaceholderAddition
                        )}
                        onSearch={e => {
                          setOpenHistory(false);
                          onSearch(e);
                        }}
                        size="large"
                        enterButton
                      />
                    </AutoComplete>
                  </div>
                  <div>
                    <SubmitButton
                      className="create-btn"
                      type="create"
                      onClick={() => setShow(true)}
                      processes={[constants.OPERATION_CREATE]}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <KnowledgeItemBasic
              show={show}
              handleClose={() => setShow(false)}
              {...handlerProps}
            />
          </Col>
        </Row>
        {!showTable ? (
          <Bam
            {...handlerProps}
            onTagClick={onTagClick}
            onClassificationClick={onClassificationClick}
          />
        ) : (searchValue !== undefined &&
            !selectedWord &&
            !selectedClassification) ||
          shouldSearch ? (
          <KnowledgeManagementSearch
            {...handlerProps}
            parentResetComponent={parentResetComponent}
            searchValue={searchValue}
            shouldSearch={shouldSearch}
            beforeChangePath={beforeOnShowKnowledgeItem}
          />
        ) : (
          <KnowledgeManagement
            {...handlerProps}
            parentResetComponent={parentResetComponent}
            beforeChangePath={beforeOnShowKnowledgeItem}
            headerTitle={labels.searchResultHeader}
            tag={selectedWord}
            classification={selectedClassification}
            isElasticSearch
          />
        )}
      </div>
    </>
  );
};

export default Home;
